import React, { useEffect, useState, useMemo } from 'react'
import FetchApi from '../../customhooks/functionFetchApi';
import Spinner from 'react-bootstrap/Spinner';
import Modal from 'react-bootstrap/Modal';
import { FaSearch, FaList, FaBuilding, FaUser, FaFileAlt, FaClock, FaUserCheck, FaFileExcel } from "react-icons/fa";
import * as XLSX from 'xlsx';

const STATUS_MAP = {
  '1001': { label: 'ร่างเอกสาร', color: '#6c757d', bg: '#f8f9fa' },
  '1002': { label: 'รอส่ง', color: '#fd7e14', bg: '#fff3e0' },
  '1003': { label: 'รออนุมัติ', color: '#f59e0b', bg: '#fffbeb' },
  '1004': { label: 'กำลังอนุมัติ', color: '#3b82f6', bg: '#eff6ff' },
  '1005': { label: 'อนุมัติแล้ว', color: '#10b981', bg: '#ecfdf5' },
  '2001': { label: 'ตีกลับ', color: '#ef4444', bg: '#fef2f2' },
  '3001': { label: 'มอบหมาย', color: '#8b5cf6', bg: '#f5f3ff' },
  '0000': { label: 'ยกเลิก', color: '#6b7280', bg: '#f9fafb' },
  '4001': { label: 'ตีกลับผู้สร้าง', color: '#dc2626', bg: '#fef2f2' },
};

const STEP_COLORS = {
  approved: { bg: '#d1fae5', border: '#10b981', text: '#065f46', badgeBg: '#10b981', badgeText: '#fff', label: 'อนุมัติแล้ว' },
  received: { bg: '#dbeafe', border: '#3b82f6', text: '#1e40af', badgeBg: '#3b82f6', badgeText: '#fff', label: 'รับแล้ว' },
  waiting: { bg: '#fef3c7', border: '#f59e0b', text: '#92400e', badgeBg: '#f59e0b', badgeText: '#fff', label: 'รอรับ' },
  pending: { bg: '#f9fafb', border: '#d1d5db', text: '#9ca3af', badgeBg: '#e5e7eb', badgeText: '#6b7280', label: 'รอดำเนินการ' },
  rejected: { bg: '#fef2f2', border: '#ef4444', text: '#991b1b', badgeBg: '#ef4444', badgeText: '#fff', label: 'ตีกลับ' },
};

const PAGE_SIZE = 10;
const MODAL_PAGE_SIZE = 20;
const APPROVE_PAGE_SIZE = 8;

const Journalstepflow = () => {
  const FetchApis = new FetchApi();
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);

  const [approveModal, setApproveModal] = useState({ show: false, loading: false, data: [], journalInfo: null, stateflow: null });
  const [excelModal, setExcelModal] = useState({ show: false });
  const [excelModalPage, setExcelModalPage] = useState(1);
  const [approveModalPage, setApproveModalPage] = useState(1);

  function openApproveModal(journal, stateflow) {
    setApproveModal({ show: true, loading: true, data: [], journalInfo: journal, stateflow });
    setApproveModalPage(1);
    FetchApis.FethcPost(`/runflow/getRunflowUserApprove`, { journalId: journal.journalId, stateflow })
      .then(res => {
        setApproveModal(prev => ({ ...prev, loading: false, data: res?.data || [] }));
      })
      .catch(() => {
        setApproveModal(prev => ({ ...prev, loading: false, data: [] }));
      });
  }

  function renderPagination(page, totalPages, setPage, total, pageSize) {
    if (totalPages <= 1) return null;
    const from = (page - 1) * pageSize + 1;
    const to = Math.min(page * pageSize, total);
    const pageNums = Array.from({ length: totalPages }, (_, i) => i + 1)
      .filter(p => Math.abs(p - page) <= 2 || p === 1 || p === totalPages);
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
        <span style={{ fontSize: 12, color: '#6b7280' }}>
          แสดง <strong>{from}</strong>–<strong>{to}</strong> จาก <strong>{total}</strong> รายการ
        </span>
        <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
          <button
            onClick={() => setPage(p => Math.max(1, p - 1))}
            disabled={page === 1}
            style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #e5e7eb', background: page === 1 ? '#f9fafb' : '#fff', color: page === 1 ? '#d1d5db' : '#374151', cursor: page === 1 ? 'not-allowed' : 'pointer', fontSize: 12, fontWeight: 600 }}
          >‹</button>
          {pageNums.map((p, i, arr) => (
            <React.Fragment key={p}>
              {i > 0 && p - arr[i - 1] > 1 && <span style={{ color: '#9ca3af', fontSize: 12, padding: '0 2px' }}>…</span>}
              <button
                onClick={() => setPage(p)}
                style={{ minWidth: 30, height: 30, borderRadius: 6, border: page === p ? 'none' : '1px solid #e5e7eb', background: page === p ? '#28B463' : '#fff', color: page === p ? '#fff' : '#374151', cursor: 'pointer', fontSize: 12, fontWeight: 600, boxShadow: page === p ? '0 2px 6px rgba(40,180,99,0.3)' : 'none' }}
              >{p}</button>
            </React.Fragment>
          ))}
          <button
            onClick={() => setPage(p => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
            style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #e5e7eb', background: page === totalPages ? '#f9fafb' : '#fff', color: page === totalPages ? '#d1d5db' : '#374151', cursor: page === totalPages ? 'not-allowed' : 'pointer', fontSize: 12, fontWeight: 600 }}
          >›</button>
        </div>
      </div>
    );
  }

  useEffect(() => {
    setLoading(true);
    FetchApis.FethcGet(`/taskflow/getStepFlowAlllist`).then((res) => {
      setAllData(res?.data?.data || []);
      setLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const groupedJournals = useMemo(() => {
    const map = {};
    allData.forEach(row => {
      const key = row.journalId;
      if (!map[key]) {
        map[key] = {
          journalId: row.journalId,
          tdscode: row.tdscode,
          revision: row.revision,
          journaltype: row.journaltype_code,
          journaltypename: row.journaltypename,
          statusflow: row.current_statusflow,
          current_stateflow: row.current_stateflow,
          createdate: row.createdate,
          createby: row.createby,
          creatorname: row.creatorname,
          steps: [],
        };
      }
      map[key].steps.push({
        stateflownow: row.step,
        approveby: row.approved_by_name,
        approvedepartment: row.step_departmentname,
        receiveby: row.received_by_name,
        waitjour: row.sent_datetime,
        recievjour: row.received_datetime,
        approvejour: row.approved_datetime,
        duration_1003_to_1004: row.minutes_wait_to_receive,
        duration_1004_to_1005: row.minutes_receive_to_approve,
        reject_type: row.reject_type,
        reject_datetime: row.reject_datetime,
        rejected_by_name: row.rejected_by_name,
        rejected_by_department: row.rejected_by_department,
        reject_to_name: row.reject_to_name,
        reject_to_department: row.reject_to_department,
      });
    });
    Object.values(map).forEach(journal => {
      journal.steps.sort((a, b) => Number(a.stateflownow) - Number(b.stateflownow));
    });
    return Object.values(map).sort((a, b) => b.journalId - a.journalId);
  }, [allData]);

  const filteredJournals = useMemo(() => {
    setCurrentPage(1);
    return groupedJournals.filter(journal => {
      const searchFields = [
        journal.tdscode, journal.revision, journal.createby, journal.creatorname, journal.journaltype,
        ...journal.steps.map(s => s.approveby || ''),
        ...journal.steps.map(s => s.approvedepartment || ''),
      ].join(' ').toLowerCase();
      const matchSearch = searchText === '' || searchFields.includes(searchText.toLowerCase());
      const allDone = journal.steps.length > 0 && journal.steps.every(s => s.approvejour);
      const matchStatus = filterStatus === 'all'
        || (filterStatus === 'done' && allDone)
        || (filterStatus === 'pending' && !allDone && journal.statusflow !== '2001' && journal.statusflow !== '4001')
        || (filterStatus === 'waiting_approval' && (journal.statusflow === '1003' || journal.statusflow === '1004'))
        || (filterStatus === 'rejected' && (journal.statusflow === '2001' || journal.statusflow === '4001'));
      return matchSearch && matchStatus;
    });
  }, [groupedJournals, searchText, filterStatus]);

  const totalPages = Math.ceil(filteredJournals.length / PAGE_SIZE);
  const pagedJournals = filteredJournals.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);


  function getPageNumbers() {
    const pages = [];
    const delta = 2;
    const left = Math.max(2, currentPage - delta);
    const right = Math.min(totalPages - 1, currentPage + delta);
    pages.push(1);
    if (left > 2) pages.push('...');
    for (let i = left; i <= right; i++) pages.push(i);
    if (right < totalPages - 1) pages.push('...');
    if (totalPages > 1) pages.push(totalPages);
    return pages;
  }

  function getStepStatus(step, current_stateflow) {
    if (Number(step.stateflownow) > Number(current_stateflow)) return 'pending';
    if (step.approvejour) return 'approved';
    if (step.recievjour) return 'received';
    if (step.waitjour) return 'waiting';
    return 'pending';
  }

  function formatDuration(minutes) {
    if (minutes === null || minutes === undefined) return null;
    const mins = Number(minutes);
    if (mins < 60) return `${mins} นาที`;
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return m > 0 ? `${h} ชม. ${m} นาที` : `${h} ชม.`;
  }

  function formatDurationDays(minutes) {
    if (minutes === null || minutes === undefined || minutes === '-') return null;
    const mins = Number(minutes);
    if (isNaN(mins)) return null;
    return `${(mins / 1440).toFixed(2)} วัน`;
  }

  function formatDurationDHM(minutes) {
    if (minutes === null || minutes === undefined || minutes === '-') return '-';
    const mins = Number(minutes);
    if (isNaN(mins)) return '-';
    const days = Math.floor(mins / 1440);
    const hours = Math.floor((mins % 1440) / 60);
    const remMins = Math.round(mins % 60);
    const parts = [];
    if (days > 0) parts.push(`${days} วัน`);
    if (hours > 0) parts.push(`${hours} ชม.`);
    if (remMins > 0 || parts.length === 0) parts.push(`${remMins} นาที`);
    return parts.join(' ');
  }

  function formatDate(dt) {
    if (!dt) return '-';
    return new Date(dt).toLocaleString('th-TH', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' });
  }

  const THAI_MONTHS = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'];
  function getThaiMonthName(dt) {
    if (!dt) return '-';
    return THAI_MONTHS[new Date(dt).getMonth()];
  }

  function exportToExcel() {
    const now = new Date();
    const dateStr = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`;

    const wb = XLSX.utils.book_new();

    // ============================================================
    // Sheet 1: สรุปเอกสาร
    // ============================================================
    const summaryHeaders = [
      'ลำดับ', 'รหัสเอกสาร (TDS)', 'Rev.', 'ประเภทเอกสาร', 'ผู้สร้างเอกสาร',
      'วันที่สร้าง', 'สถานะ', 'จำนวนขั้นตอนทั้งหมด', 'ขั้นตอนที่อนุมัติแล้ว',
      'ความคืบหน้า (%)', 'วันที่ส่งครั้งแรก', 'วันที่อนุมัติล่าสุด', 'เวลารวมทั้งหมด (นาที)', 'เวลารวมทั้งหมด (วัน)',
    ];

    const summaryData = filteredJournals.map((j, i) => {
      const statusInfo = STATUS_MAP[j.statusflow] || { label: j.statusflow };
      const allDone = j.steps.length > 0 && j.steps.every(s => s.approvejour);
      const completedSteps = j.steps.filter(s => s.approvejour).length;
      const progressPct = j.steps.length > 0 ? Math.round((completedSteps / j.steps.length) * 100) : 0;
      const firstSent = j.steps.find(s => s.waitjour)?.waitjour;
      const lastApproved = [...j.steps].reverse().find(s => s.approvejour)?.approvejour;
      let totalMinutes = '-';
      if (firstSent && lastApproved) {
        const diff = Math.round((new Date(lastApproved) - new Date(firstSent)) / 60000);
        if (diff > 0) totalMinutes = diff;
      }
      return [
        i + 1,
        j.tdscode || '-',
        j.revision || '-',
        j.journaltypename || j.journaltype || '-',
        j.creatorname || j.createby || '-',
        formatDate(j.createdate),
        allDone ? 'เสร็จเรียบร้อย' : statusInfo.label,
        j.steps.length,
        completedSteps,
        `${progressPct}%`,
        firstSent ? formatDate(firstSent) : '-',
        lastApproved ? formatDate(lastApproved) : '-',
        totalMinutes,
        formatDurationDays(totalMinutes) || '-',
      ];
    });

    const ws1 = XLSX.utils.aoa_to_sheet([summaryHeaders, ...summaryData]);
    ws1['!cols'] = [
      { wch: 7 }, { wch: 22 }, { wch: 7 }, { wch: 22 }, { wch: 20 },
      { wch: 20 }, { wch: 18 }, { wch: 20 }, { wch: 20 },
      { wch: 16 }, { wch: 22 }, { wch: 22 }, { wch: 22 }, { wch: 18 },
    ];
    ws1['!views'] = [{ state: 'frozen', xSplit: 0, ySplit: 1 }];
    ws1['!autofilter'] = { ref: `A1:N${summaryData.length + 1}` };
    XLSX.utils.book_append_sheet(wb, ws1, 'สรุปเอกสาร');

    // ============================================================
    // Sheet 2: รายละเอียดขั้นตอน (wide format — matches popup)
    // ============================================================
    function colLetter(n) {
      let s = '', c = n + 1;
      while (c > 0) { const m = (c - 1) % 26; s = String.fromCharCode(65 + m) + s; c = Math.floor((c - 1) / 26); }
      return s;
    }

    const maxSteps = filteredJournals.length > 0
      ? Math.max(...filteredJournals.map(j => j.steps.length))
      : 0;
    const DOC_COLS = 11;
    const stepSubHeaders = ['แผนก', 'สถานะ', 'วันที่ส่ง', 'รอรับ (นาที)', 'รอรับ (วัน-เวลา)', 'วันที่รับ', 'รับ→อนุมัติ (นาที)', 'รับ→อนุมัติ (วัน-เวลา)', 'วันที่อนุมัติ', 'รอส่งต่อ (นาที)', 'รอส่งต่อ (วัน-เวลา)'];
    const S = stepSubHeaders.length;

    const groupRow = ['ข้อมูลเอกสาร', ...Array(DOC_COLS - 1).fill('')];
    for (let si = 0; si < maxSteps; si++) {
      groupRow.push(`Step ${si + 1}`);
      for (let fi = 1; fi < S; fi++) groupRow.push('');
    }

    const fieldRow = ['#', 'รหัสเอกสาร (TDS)', 'Rev.', 'สถานะ', 'ขั้นตอน', '%', '⏱ รวม (นาที)', '⏱ รวม (วัน)', 'ข้อมูลผู้สร้าง', 'ประเภทงาน', 'เดือนที่สร้าง'];
    for (let si = 0; si < maxSteps; si++) stepSubHeaders.forEach(h => fieldRow.push(h));

    const detailRows = filteredJournals.map((j, ji) => {
      const statusInfo = STATUS_MAP[j.statusflow] || { label: j.statusflow };
      const allDone = j.steps.length > 0 && j.steps.every(s => s.approvejour);
      const completedSteps = j.steps.filter(s => s.approvejour).length;
      const progressPct = j.steps.length > 0 ? Math.round((completedSteps / j.steps.length) * 100) : 0;
      const displayStatus = allDone ? 'เสร็จเรียบร้อย' : (statusInfo.label || j.statusflow);
      const firstSent = j.steps.find(s => s.waitjour)?.waitjour;
      const lastApproved = [...j.steps].reverse().find(s => s.approvejour)?.approvejour;
      let totalMinutes = '-';
      if (firstSent && lastApproved) {
        const diff = Math.round((new Date(lastApproved) - new Date(firstSent)) / 60000);
        if (diff > 0) totalMinutes = diff;
      }
      const row = [
        ji + 1, j.tdscode || '-', j.revision || '-', displayStatus, `${completedSteps}/${j.steps.length}`, `${progressPct}%`, totalMinutes,
        formatDurationDays(totalMinutes) || '-',
        j.creatorname || j.createby || '-',
        j.journaltypename || j.journaltype || '-',
        getThaiMonthName(j.createdate),
      ];
      for (let si = 0; si < maxSteps; si++) {
        const step = j.steps[si];
        if (!step) { for (let fi = 0; fi < S; fi++) row.push('-'); continue; }
        const nextStep = si < j.steps.length - 1 ? j.steps[si + 1] : null;
        const stepStatus = getStepStatus(step, j.current_stateflow);
        const statusLabel = STEP_COLORS[stepStatus]?.label || stepStatus;
        const waitToReceive = (step.duration_1003_to_1004 != null) ? Number(step.duration_1003_to_1004) : '-';
        let receiveToApprove = '-';
        if (step.recievjour && step.approvejour) {
          const diff = Math.round((new Date(step.approvejour) - new Date(step.recievjour)) / 60000);
          if (diff > 0) receiveToApprove = diff;
        }
        let betweenSteps = '-';
        if (step.approvejour && nextStep?.recievjour) {
          const diff = Math.round((new Date(nextStep.recievjour) - new Date(step.approvejour)) / 60000);
          if (diff > 0) betweenSteps = diff;
        }
        row.push(
          step.approvedepartment || '-', statusLabel,
          step.waitjour ? formatDate(step.waitjour) : '-', waitToReceive, formatDurationDHM(waitToReceive),
          step.recievjour ? formatDate(step.recievjour) : '-', receiveToApprove, formatDurationDHM(receiveToApprove),
          step.approvejour ? formatDate(step.approvejour) : '-', betweenSteps, formatDurationDHM(betweenSteps)
        );
      }
      return row;
    });

    const totalCols = DOC_COLS + maxSteps * S;
    const ws2 = XLSX.utils.aoa_to_sheet([groupRow, fieldRow, ...detailRows]);
    const merges2 = [{ s: { r: 0, c: 0 }, e: { r: 0, c: DOC_COLS - 1 } }];
    for (let si = 0; si < maxSteps; si++) {
      const sc = DOC_COLS + si * S;
      merges2.push({ s: { r: 0, c: sc }, e: { r: 0, c: sc + S - 1 } });
    }
    ws2['!merges'] = merges2;
    const cols2 = [{ wch: 5 }, { wch: 22 }, { wch: 7 }, { wch: 18 }, { wch: 12 }, { wch: 8 }, { wch: 14 }, { wch: 12 }, { wch: 20 }, { wch: 18 }, { wch: 14 }];
    for (let si = 0; si < maxSteps; si++) {
      cols2.push({ wch: 22 }, { wch: 14 }, { wch: 20 }, { wch: 12 }, { wch: 18 }, { wch: 20 }, { wch: 18 }, { wch: 18 }, { wch: 20 }, { wch: 16 }, { wch: 18 });
    }
    ws2['!cols'] = cols2;
    ws2['!views'] = [{ state: 'frozen', xSplit: 0, ySplit: 2 }];
    ws2['!autofilter'] = { ref: `A2:${colLetter(totalCols - 1)}${detailRows.length + 2}` };
    XLSX.utils.book_append_sheet(wb, ws2, 'รายละเอียดขั้นตอน');

    XLSX.writeFile(wb, `Flow_อนุมัติเอกสาร_${dateStr}.xlsx`);
  }

  const cardStyle = {
    cursor: 'pointer',
    backgroundColor: 'rgba(255,255,255,0.15)',
    border: '1.5px solid rgba(255,255,255,0.3)',
    borderRadius: 10,
    padding: '8px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    minWidth: 140,
    transition: 'background 0.2s',
  };
  const iconBoxStyle = {
    backgroundColor: 'rgba(255,255,255,0.25)',
    borderRadius: 8,
    padding: 7,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const statusCounts = useMemo(() => {
    const counts = { done: 0, pending: 0, waiting_approval: 0, rejected: 0 };
    groupedJournals.forEach(j => {
      const allDone = j.steps.length > 0 && j.steps.every(s => s.approvejour);
      if (allDone) {
        counts.done++;
      } else if (j.statusflow === '2001' || j.statusflow === '4001') {
        counts.rejected++;
      } else if (j.statusflow === '1003' || j.statusflow === '1004') {
        counts.waiting_approval++;
        counts.pending++;
      } else {
        counts.pending++;
      }
    });
    return counts;
  }, [groupedJournals]);

  return (
    <div style={{ backgroundColor: '#f4f6f8', minHeight: '100vh' }}>

      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, #1a7f5a 0%, #28B463 100%)',
        padding: '16px 24px 20px',
        boxShadow: '0 3px 10px rgba(0,0,0,0.15)',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12 }}>
          <div>
            <div style={{ color: '#fff', fontSize: 22, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8 }}>
              <FaFileAlt /> Flow การอนุมัติเอกสาร
            </div>
            <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: 13, marginTop: 3 }}>
              แสดงขั้นตอนการอนุมัติทั้งหมด {groupedJournals.length} รายการ
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 4, flexWrap: 'wrap' }}>
            <div style={{ position: 'relative' }}>
              <FaSearch style={{ position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', color: '#aaa', fontSize: 13 }} />
              <input
                type='text'
                placeholder='ค้นหา TDS / ผู้อนุมัติ / แผนก...'
                value={searchText}
                onChange={e => setSearchText(e.target.value)}
                style={{
                  paddingLeft: 34, paddingRight: 14, paddingTop: 8, paddingBottom: 8,
                  borderRadius: 20, border: 'none', fontSize: 13, outline: 'none', width: 280,
                  boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                }}
              />
            </div>
            <button
              onClick={() => { setExcelModal({ show: true }); setExcelModalPage(1); }}
              disabled={filteredJournals.length === 0}
              title={`ดูตัวอย่างและ Export ข้อมูล ${filteredJournals.length} รายการ เป็น Excel`}
              style={{
                display: 'flex', alignItems: 'center', gap: 7,
                padding: '8px 18px', borderRadius: 20, border: '1.5px solid rgba(255,255,255,0.6)',
                background: filteredJournals.length === 0 ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.22)',
                color: filteredJournals.length === 0 ? 'rgba(255,255,255,0.4)' : '#fff',
                fontSize: 13, fontWeight: 600, cursor: filteredJournals.length === 0 ? 'not-allowed' : 'pointer',
                boxShadow: filteredJournals.length > 0 ? '0 2px 8px rgba(0,0,0,0.15)' : 'none',
                transition: 'all 0.2s', whiteSpace: 'nowrap',
              }}
              onMouseEnter={e => { if (filteredJournals.length > 0) e.currentTarget.style.background = 'rgba(255,255,255,0.32)'; }}
              onMouseLeave={e => { if (filteredJournals.length > 0) e.currentTarget.style.background = 'rgba(255,255,255,0.22)'; }}
            >
              <FaFileExcel size={14} />
              Export Excel
              <span style={{
                background: 'rgba(255,255,255,0.25)', borderRadius: 10,
                padding: '1px 8px', fontSize: 11, fontWeight: 700,
              }}>
                {filteredJournals.length}
              </span>
            </button>
          </div>
        </div>

        {/* Stat Cards */}
        <div style={{ display: 'flex', gap: 10, marginTop: 14, flexWrap: 'wrap' }}>
          {/* ทั้งหมด */}
          <div onClick={() => setFilterStatus('all')} style={{ ...cardStyle, border: filterStatus === 'all' ? '1.5px solid #fff' : '1.5px solid rgba(255,255,255,0.3)' }}>
            <div style={iconBoxStyle}><FaList size={14} color="#fff" /></div>
            <div>
              <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 10 }}>ทั้งหมด</div>
              <div style={{ color: '#fff', fontSize: 22, fontWeight: 700, lineHeight: 1.1 }}>{groupedJournals.length}</div>
            </div>
          </div>
          {/* รอดำเนินการ */}
          <div onClick={() => setFilterStatus('pending')} style={{ ...cardStyle, border: filterStatus === 'pending' ? '1.5px solid #fff' : '1.5px solid rgba(255,255,255,0.3)' }}>
            <div style={{ ...iconBoxStyle, backgroundColor: 'rgba(245,158,11,0.35)' }}><FaClock size={14} color="#fff" /></div>
            <div>
              <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 10 }}>รอดำเนินการ</div>
              <div style={{ color: '#fff', fontSize: 22, fontWeight: 700, lineHeight: 1.1 }}>{statusCounts.pending}</div>
            </div>
          </div>
          {/* รออนุมัติ */}
          <div onClick={() => setFilterStatus('waiting_approval')} style={{ ...cardStyle, border: filterStatus === 'waiting_approval' ? '1.5px solid #fff' : '1.5px solid rgba(255,255,255,0.3)' }}>
            <div style={{ ...iconBoxStyle, backgroundColor: 'rgba(59,130,246,0.35)' }}><FaUserCheck size={14} color="#fff" /></div>
            <div>
              <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 10 }}>รออนุมัติ</div>
              <div style={{ color: '#fff', fontSize: 22, fontWeight: 700, lineHeight: 1.1 }}>{statusCounts.waiting_approval}</div>
            </div>
          </div>
          {/* ตีกลับ */}
          <div onClick={() => setFilterStatus('rejected')} style={{ ...cardStyle, border: filterStatus === 'rejected' ? '1.5px solid #fff' : '1.5px solid rgba(255,255,255,0.3)' }}>
            <div style={{ ...iconBoxStyle, backgroundColor: 'rgba(239,68,68,0.35)' }}><FaFileAlt size={14} color="#fff" /></div>
            <div>
              <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 10 }}>ตีกลับ</div>
              <div style={{ color: '#fff', fontSize: 22, fontWeight: 700, lineHeight: 1.1 }}>{statusCounts.rejected}</div>
            </div>
          </div>
          {/* เสร็จแล้ว */}
          <div onClick={() => setFilterStatus('done')} style={{ ...cardStyle, border: filterStatus === 'done' ? '1.5px solid #fff' : '1.5px solid rgba(255,255,255,0.3)' }}>
            <div style={{ ...iconBoxStyle, backgroundColor: 'rgba(16,185,129,0.35)' }}><FaUserCheck size={14} color="#fff" /></div>
            <div>
              <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 10 }}>เสร็จแล้ว</div>
              <div style={{ color: '#fff', fontSize: 22, fontWeight: 700, lineHeight: 1.1 }}>{statusCounts.done}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div style={{ padding: '20px 24px' }}>
        {loading ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 80, gap: 14 }}>
            <Spinner animation="grow" variant="success" style={{ width: 48, height: 48 }} />
            <div style={{ color: '#6c757d', fontSize: 14 }}>กำลังโหลดข้อมูล...</div>
          </div>
        ) : filteredJournals.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 80, color: '#9ca3af', fontSize: 15 }}>ไม่พบข้อมูล</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {pagedJournals.map(journal => {
              const status = STATUS_MAP[journal.statusflow] || { label: journal.statusflow, color: '#6c757d', bg: '#f8f9fa' };
              const completedSteps = journal.steps.filter(s => s.approvejour).length;
              const progressPct = journal.steps.length > 0 ? Math.round((completedSteps / journal.steps.length) * 100) : 0;
              const allStepsDone = journal.steps.length > 0 && completedSteps === journal.steps.length;
              const displayStatus = allStepsDone ? { label: 'เสร็จเรียบร้อย', color: '#059669', bg: '#d1fae5' } : status;

              return (
                <div key={journal.journalId} style={{
                  backgroundColor: '#fff',
                  borderRadius: 14,
                  boxShadow: '0 2px 10px rgba(0,0,0,0.07)',
                  overflow: 'hidden',
                  borderLeft: `5px solid ${displayStatus.color}`,
                  outline: journal.steps.length > 0 ? `2px solid ${displayStatus.color}66` : 'none',
                  outlineOffset: -1,
                }}>
                  {/* Journal header */}
                  <div style={{
                    padding: '12px 18px 10px',
                    borderBottom: '1px solid #f3f4f6',
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8,
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                      <span style={{ fontWeight: 700, fontSize: 15, color: '#1f2937' }}>{journal.tdscode}</span>
                      <span style={{ fontSize: 11, color: '#6b7280', background: '#f3f4f6', borderRadius: 6, padding: '2px 8px' }}>Rev.{journal.revision}</span>
                      {journal.journaltype && (
                        <span style={{ fontSize: 11, color: '#047857', background: '#d1fae5', borderRadius: 6, padding: '2px 8px', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 3 }}>
                          <FaFileAlt size={9} />ประเภท: {journal.journaltypename || journal.journaltype}
                        </span>
                      )}
                      <span style={{ fontSize: 11, color: '#374151', background: '#f3f4f6', borderRadius: 6, padding: '2px 8px', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 3 }}>
                        <FaUser size={9} color="#6b7280" />ผู้สร้าง: {journal.creatorname || journal.createby}
                      </span>
                      <span style={{ fontSize: 11, color: '#9ca3af' }}>
                        <FaClock size={10} style={{ marginRight: 3 }} />{formatDate(journal.createdate)}
                      </span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                      <span style={{ fontSize: 11, color: '#6b7280' }}>{completedSteps}/{journal.steps.length} ขั้นตอน</span>
                      <span style={{
                        fontSize: 11, fontWeight: 700,
                        color: displayStatus.color, background: displayStatus.bg,
                        padding: '4px 14px', borderRadius: 20, border: `1px solid ${displayStatus.color}44`,
                      }}>{displayStatus.label}</span>
                    </div>
                  </div>

                  {/* Progress bar */}
                  <div style={{ height: 3, background: '#f3f4f6' }}>
                    <div style={{ height: '100%', width: `${progressPct}%`, background: displayStatus.color, transition: 'width 0.5s ease', borderRadius: 2 }} />
                  </div>

                  {/* Horizontal step flow */}
                  <div style={{ padding: '18px 20px 16px', overflowX: 'auto' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', minWidth: 'max-content' }}>
                      {journal.steps.map((step, idx) => {
                        const stepStatus = getStepStatus(step, journal.current_stateflow);
                        const isLast = idx === journal.steps.length - 1;
                        const isRejected = journal.statusflow === '4001';
                        const rejectionStepIdx = isRejected
                          ? (() => {
                              // ค้นหา step ที่มี reject_type='4001' ก่อน (กรณี 4001 บันทึกที่ stateflow ผิด)
                              const byRejectType = journal.steps.findIndex(s => s.reject_type === '4001');
                              if (byRejectType !== -1) return byRejectType;
                              // fallback: หา step ที่ส่งแล้วแต่ยังไม่อนุมัติ
                              return journal.steps.reduce((found, s, i) =>
                                ((s.waitjour || s.recievjour) && !s.approvejour) ? i : found, -1);
                            })()
                          : -1;
                        const isRejectionStep4001 = isRejected && idx === rejectionStepIdx;
                        const showStepDetails = !isRejected || isRejectionStep4001;
                        const is2001 = journal.statusflow === '2001';
                        const rejectionStepIdx2001 = is2001
                          ? journal.steps.reduce((found, s, i) => (s.recievjour && !s.approvejour) ? i : found, -1)
                          : -1;
                        const isRejectionStep2001 = is2001 && idx === rejectionStepIdx2001;
                        const isAnyRejectionStep = isRejectionStep2001 || isRejectionStep4001;
                        const sc = STEP_COLORS[isAnyRejectionStep ? 'rejected' : stepStatus];
                        const connectorColor = sc.border;

                        let stepTotalMinutes = null;
                        if (step.waitjour && step.approvejour) {
                          const diff = Math.round((new Date(step.approvejour) - new Date(step.waitjour)) / 60000);
                          if (diff > 0) stepTotalMinutes = diff;
                        }

                        const nextStep = !isLast ? journal.steps[idx + 1] : null;
                        let stepToNextMinutes = null;
                        if (step.approvejour && nextStep?.recievjour) {
                          const diff = Math.round((new Date(nextStep.recievjour) - new Date(step.approvejour)) / 60000);
                          if (diff > 0) stepToNextMinutes = diff;
                        }

                        const approveMinutes = (() => {
                          if (step.recievjour && step.approvejour) {
                            const diff = Math.round((new Date(step.approvejour) - new Date(step.recievjour)) / 60000);
                            return diff > 0 ? diff : null;
                          }
                          return null;
                        })();

                        const isPastOrCurrent = Number(step.stateflownow) <= Number(journal.current_stateflow);

                        return (
                          <React.Fragment key={idx}>
                            {/* Step node */}
                            <div
                              onClick={(stepStatus === 'pending' || stepStatus === 'waiting') ? () => openApproveModal(journal, step.stateflownow) : undefined}
                              title={(stepStatus === 'pending' || stepStatus === 'waiting') ? 'คลิกดูรายละเอียดผู้รออนุมัติ' : undefined}
                              style={{
                                display: 'flex', flexDirection: 'column', alignItems: 'center',
                                width: isPastOrCurrent ? 158 : 120,
                                cursor: (stepStatus === 'pending' || stepStatus === 'waiting') ? 'pointer' : 'default',
                              }}>

                              {/* Circle */}
                              <div style={{
                                width: 46, height: 46, borderRadius: '50%',
                                background: sc.bg,
                                border: `3px solid ${sc.border}`,
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: stepStatus === 'approved' ? 20 : 16,
                                color: sc.border, fontWeight: 700,
                                boxShadow: `0 0 0 4px ${sc.bg}`,
                                position: 'relative', zIndex: 1,
                              }}>
                                {stepStatus === 'approved' ? '✓' : isAnyRejectionStep ? '✕' : step.stateflownow}
                              </div>

                              {/* Compact department label (collapsed only) */}
                              {!isPastOrCurrent && (
                                <div style={{
                                  marginTop: 8, textAlign: 'center',
                                  width: 112, padding: '8px 8px 6px',
                                  background: step.stateflownow ? sc.border + '22' : sc.bg,
                                  border: `1.5px dashed ${sc.border}`,
                                  borderRadius: 10,
                                  transition: 'box-shadow 0.15s',
                                  boxShadow: step.stateflownow
                                    ? `0 0 0 3px ${sc.border}44, 0 2px 10px ${sc.border}33`
                                    : '0 1px 4px rgba(0,0,0,0.06)',
                                }}>
                                  <div style={{
                                    fontSize: 9, fontWeight: 700,
                                    color: sc.badgeText, background: sc.badgeBg,
                                    borderRadius: 6, padding: '2px 6px',
                                    marginBottom: 4, display: 'inline-block',
                                  }}>
                                    {sc.label}
                                  </div>
                                  <div style={{
                                    fontSize: 10, fontWeight: 700, color: sc.text,
                                    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                  }}>
                                    {step.approvedepartment || '-'}
                                  </div>
                                  {step.approveby && (
                                    <div style={{
                                      fontSize: 9, color: '#6b7280',
                                      overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                      marginTop: 2,
                                    }}>
                                      {step.approveby}
                                    </div>
                                  )}
                                  <div style={{ fontSize: 9, color: sc.border, marginTop: 5, fontWeight: 600 }}>
                                    คลิกดูรายละเอียด
                                  </div>
                                </div>
                              )}

                              {/* Info card */}
                              {isPastOrCurrent && <div
                                style={{
                                  marginTop: 10,
                                  background: step.stateflownow ? sc.border + '22' : sc.bg,
                                  border: stepStatus === 'waiting'
                                    ? `2.5px solid ${sc.border}`
                                    : stepStatus === 'approved' || stepStatus === 'received'
                                      ? `1.5px solid ${sc.border}88`
                                      : `1.5px solid ${sc.border}55`,
                                  borderRadius: 12,
                                  padding: '10px 10px 8px',
                                  width: 158,
                                  boxShadow: step.stateflownow
                                    ? `0 0 0 3px ${sc.border}44, 0 2px 10px ${sc.border}33`
                                    : stepStatus === 'waiting'
                                      ? `0 0 0 3px ${sc.border}33, 0 2px 8px rgba(0,0,0,0.08)`
                                      : '0 1px 4px rgba(0,0,0,0.05)',
                                }}
                              >
                                {/* Status badge + step label */}
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                                  <span style={{ fontSize: 9, color: '#9ca3af', fontWeight: 600 }}>
                                    ขั้นตอนที่ {step.stateflownow}
                                  </span>
                                  <span style={{
                                    fontSize: 9, fontWeight: 700,
                                    color: sc.badgeText, background: sc.badgeBg,
                                    borderRadius: 8, padding: '2px 7px',
                                  }}>
                                    {sc.label}
                                  </span>
                                </div>

                                {/* Department row */}
                                {showStepDetails && (
                                  <div style={{
                                    display: 'flex', alignItems: 'center', gap: 5,
                                    background: 'rgba(255,255,255,0.8)',
                                    border: `1px solid ${sc.border}55`,
                                    borderRadius: 7,
                                    padding: '4px 7px',
                                    marginBottom: 6,
                                  }}>
                                    <FaBuilding size={10} color={sc.border} style={{ flexShrink: 0 }} />
                                    <span style={{
                                      fontSize: 11, fontWeight: 700, color: sc.text,
                                      overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                    }}>
                                      {step.approvedepartment || '-'}
                                    </span>
                                  </div>
                                )}

                                {/* Divider */}
                                {showStepDetails && <div style={{ height: 1, background: `${sc.border}22`, marginBottom: 5 }} />}

                                {/* Received row */}
                                {showStepDetails && step.recievjour && (
                                  <div style={{ marginBottom: 3 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                      <span style={{ fontSize: 9, color: '#3b82f6', fontWeight: 600, flexShrink: 0 }}>รับ:</span>
                                      <span style={{
                                        fontSize: 10, fontWeight: 700, color: '#1d4ed8',
                                        overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                      }}>
                                        {step.receiveby || '-'}
                                      </span>
                                    </div>
                                    <div style={{ fontSize: 9, color: '#3b82f6', marginTop: 1 }}>
                                      {formatDate(step.recievjour)}
                                    </div>
                                  </div>
                                )}

                                {/* Approved row */}
                                {showStepDetails && step.approvejour && (
                                  <div style={{ marginBottom: 3 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                      <span style={{ fontSize: 9, color: '#10b981', fontWeight: 600, flexShrink: 0 }}>อนุมัติ:</span>
                                      <span style={{
                                        fontSize: 10, fontWeight: 700, color: '#065f46',
                                        overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                      }}>
                                        {step.approveby || '-'}
                                      </span>
                                    </div>
                                    <div style={{ fontSize: 9, color: '#10b981', marginTop: 1 }}>
                                      {formatDate(step.approvejour)}
                                    </div>
                                  </div>
                                )}

                                {/* Waiting only */}
                                {showStepDetails && !step.recievjour && step.waitjour && (
                                  <div style={{ fontSize: 9, color: '#f59e0b', fontWeight: 600 }}>
                                    ส่งเมื่อ {formatDate(step.waitjour)}
                                  </div>
                                )}

                                {/* คลิกดูรายละเอียดสำหรับ waiting */}
                                {stepStatus === 'waiting' && (
                                  <div style={{
                                    marginTop: 6, fontSize: 9, fontWeight: 600,
                                    color: sc.border, textAlign: 'center',
                                    borderTop: `1px dashed ${sc.border}44`,
                                    paddingTop: 5,
                                  }}>
                                    คลิกดูรายละเอียด
                                  </div>
                                )}

                              </div>}

                              {/* Duration 1004→1005 ใต้เส้น step flow */}
                              {isPastOrCurrent && showStepDetails && approveMinutes !== null && (
                                <div style={{
                                  marginTop: 6,
                                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
                                  background: '#eff6ff',
                                  border: '1px solid #bfdbfe',
                                  borderRadius: 8,
                                  padding: '4px 10px',
                                  width: 158,
                                  boxSizing: 'border-box',
                                }}>
                                  <FaClock size={9} color="#3b82f6" />
                                  <span style={{ fontSize: 9, color: '#6b7280' }}>รับ→อนุมัติ</span>
                                  <span style={{ fontSize: 9, fontWeight: 700, color: '#1d4ed8' }}>
                                    {formatDuration(approveMinutes)}
                                  </span>
                                </div>
                              )}
                            </div>

                            {/* Connector */}
                            {!isLast && (
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', paddingTop: 22, flexShrink: 0 }}>
                                {/* Arrow line */}
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <div style={{ width: 28, height: 2.5, background: connectorColor, borderRadius: 2 }} />
                                  <div style={{
                                    width: 0, height: 0,
                                    borderTop: '6px solid transparent',
                                    borderBottom: '6px solid transparent',
                                    borderLeft: `8px solid ${connectorColor}`,
                                  }} />
                                </div>
                                {/* Duration ส่ง→รับ */}
                                {isPastOrCurrent && showStepDetails && formatDuration(step.duration_1003_to_1004) && (
                                  <div style={{ marginTop: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                    <span style={{ fontSize: 9, color: '#9ca3af', lineHeight: 1.2 }}>ส่ง→รับ</span>
                                    <span style={{ fontSize: 9, fontWeight: 700, color: '#f59e0b', lineHeight: 1.2 }}>
                                      {formatDuration(step.duration_1003_to_1004)}
                                    </span>
                                  </div>
                                )}
                                {/* Total step duration */}
                                {isPastOrCurrent && showStepDetails && stepTotalMinutes !== null && (
                                  <div style={{ marginTop: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                    <span style={{ fontSize: 9, color: '#9ca3af', lineHeight: 1.2 }}>รวม</span>
                                    <span style={{ fontSize: 9, fontWeight: 700, color: '#6366f1', lineHeight: 1.2 }}>
                                      {formatDuration(stepTotalMinutes)}
                                    </span>
                                  </div>
                                )}
                                {/* อนุมัติ → รับเอกสาร step ถัดไป */}
                                {isPastOrCurrent && showStepDetails && stepToNextMinutes !== null && (
                                  <div style={{ marginTop: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                    <span style={{ fontSize: 9, color: '#9ca3af', lineHeight: 1.2 }}>อนุมัติ→รับ</span>
                                    <span style={{ fontSize: 9, fontWeight: 700, color: '#ec4899', lineHeight: 1.2 }}>
                                      {formatDuration(stepToNextMinutes)}
                                    </span>
                                  </div>
                                )}
                              </div>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Pagination */}
        {!loading && filteredJournals.length > 0 && (
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            flexWrap: 'wrap', gap: 10, marginTop: 20,
            padding: '12px 18px',
            backgroundColor: '#fff',
            borderRadius: 12,
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
          }}>
            <div style={{ fontSize: 13, color: '#6b7280' }}>
              แสดง <strong>{(currentPage - 1) * PAGE_SIZE + 1}</strong>–<strong>{Math.min(currentPage * PAGE_SIZE, filteredJournals.length)}</strong> จาก <strong>{filteredJournals.length}</strong> รายการ
            </div>
            <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
              <button
                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                disabled={currentPage === 1}
                style={{
                  padding: '5px 14px', borderRadius: 8, border: '1px solid #e5e7eb',
                  background: currentPage === 1 ? '#f9fafb' : '#fff',
                  color: currentPage === 1 ? '#d1d5db' : '#374151',
                  cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                  fontSize: 13, fontWeight: 600,
                }}
              >‹ ก่อนหน้า</button>

              {getPageNumbers().map((p, i) =>
                p === '...' ? (
                  <span key={`ellipsis-${i}`} style={{ padding: '0 4px', color: '#9ca3af', fontSize: 13 }}>…</span>
                ) : (
                  <button
                    key={p}
                    onClick={() => setCurrentPage(p)}
                    style={{
                      width: 36, height: 36, borderRadius: 8,
                      border: currentPage === p ? 'none' : '1px solid #e5e7eb',
                      background: currentPage === p ? '#28B463' : '#fff',
                      color: currentPage === p ? '#fff' : '#374151',
                      cursor: 'pointer', fontSize: 13, fontWeight: 600,
                      boxShadow: currentPage === p ? '0 2px 6px rgba(40,180,99,0.35)' : 'none',
                    }}
                  >{p}</button>
                )
              )}

              <button
                onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                disabled={currentPage === totalPages}
                style={{
                  padding: '5px 14px', borderRadius: 8, border: '1px solid #e5e7eb',
                  background: currentPage === totalPages ? '#f9fafb' : '#fff',
                  color: currentPage === totalPages ? '#d1d5db' : '#374151',
                  cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                  fontSize: 13, fontWeight: 600,
                }}
              >ถัดไป ›</button>
            </div>
          </div>
        )}
      </div>

      {/* Modal Preview ก่อน Export Excel */}
      <Modal
        show={excelModal.show}
        onHide={() => setExcelModal({ show: false })}
        centered
        size="xl"
      >
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #1a7f5a 0%, #28B463 100%)', borderBottom: 'none' }}>
          <Modal.Title style={{ color: '#fff', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
            <FaFileExcel size={16} />
            ตัวอย่างข้อมูลก่อน Export — {filteredJournals.length} รายการ
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: 0, maxHeight: '70vh', overflowY: 'auto', overflowX: 'auto' }}>
          {(() => {
            const maxSteps = filteredJournals.length > 0
              ? Math.max(...filteredJournals.map(j => j.steps.length))
              : 0;

            const STEP_PALETTE = [
              { grpBg: '#eff6ff', grpBorder: '#3b82f6', grpText: '#1e40af', fieldBg: '#f8fbff' },
              { grpBg: '#f0fdf4', grpBorder: '#22c55e', grpText: '#15803d', fieldBg: '#f7fdf9' },
              { grpBg: '#faf5ff', grpBorder: '#a855f7', grpText: '#7e22ce', fieldBg: '#fdf8ff' },
              { grpBg: '#fff7ed', grpBorder: '#f97316', grpText: '#c2410c', fieldBg: '#fffbf7' },
              { grpBg: '#fef2f2', grpBorder: '#ef4444', grpText: '#b91c1c', fieldBg: '#fffafa' },
            ];

            const stepSubFields = [
              { label: 'แผนก' },
              { label: 'สถานะ' },
              { label: 'วันที่ส่ง' },
              { label: '⏳ รอรับ\n(นาที)' },
              { label: '⏳ รอรับ\n(วัน-เวลา)' },
              { label: 'วันที่รับ' },
              { label: '✅ รับ→อนุมัติ\n(นาที)' },
              { label: '✅ รับ→อนุมัติ\n(วัน-เวลา)' },
              { label: 'วันที่อนุมัติ' },
              { label: '🔁 รอส่งต่อ\n(นาที)' },
              { label: '🔁 รอส่งต่อ\n(วัน-เวลา)', isLast: true },
            ];
            const S = stepSubFields.length;

            const durBadge = (val, colText, colBg) => val != null
              ? <span style={{ fontWeight: 700, fontSize: 11, color: colText, background: colBg, padding: '2px 7px', borderRadius: 6, whiteSpace: 'nowrap' }}>{formatDuration(val)}</span>
              : <span style={{ color: '#d1d5db' }}>-</span>;

            return (
              <table style={{ minWidth: 'max-content', width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead style={{ position: 'sticky', top: 0, zIndex: 2 }}>
                  {/* Row 1: group headers */}
                  <tr>
                    <th colSpan={8} style={{
                      padding: '6px 12px', textAlign: 'center', fontWeight: 700, fontSize: 10,
                      background: '#f0fdf4', color: '#065f46',
                      borderBottom: '1px solid #bbf7d0', borderRight: '3px solid #94a3b8',
                    }}>ข้อมูลเอกสาร</th>
                    {Array.from({ length: maxSteps }, (_, si) => {
                      const pal = STEP_PALETTE[si % STEP_PALETTE.length];
                      return (
                        <th key={si} colSpan={S} style={{
                          padding: '6px 12px', textAlign: 'center', fontWeight: 700, fontSize: 11,
                          background: pal.grpBg, color: pal.grpText,
                          borderBottom: `1px solid ${pal.grpBorder}55`,
                          borderLeft: `3px solid ${pal.grpBorder}`,
                        }}>
                          Step {si + 1}
                        </th>
                      );
                    })}
                  </tr>
                  {/* Row 2: field headers */}
                  <tr>
                    {[
                      { label: '#', bg: '#f0fdf4', color: '#065f46' },
                      { label: 'รหัสเอกสาร (TDS)', bg: '#f0fdf4', color: '#065f46' },
                      { label: 'Rev.', bg: '#f0fdf4', color: '#065f46' },
                      { label: 'สถานะ', bg: '#f0fdf4', color: '#065f46' },
                      { label: 'ขั้นตอน', bg: '#f0fdf4', color: '#065f46' },
                      { label: '%', bg: '#f0fdf4', color: '#065f46' },
                      { label: '⏱ รวม', bg: '#f0fdf4', color: '#6d28d9' },
                      { label: '⏱ รวม (วัน)', bg: '#f0fdf4', color: '#6d28d9', borderRight: '3px solid #94a3b8' },
                    ].map((h, i) => (
                      <th key={i} style={{
                        padding: '7px 10px', textAlign: 'left', fontWeight: 700, fontSize: 10,
                        background: h.bg, color: h.color, borderBottom: '2px solid #e5e7eb',
                        borderRight: h.borderRight || undefined, whiteSpace: 'nowrap',
                      }}>{h.label}</th>
                    ))}
                    {Array.from({ length: maxSteps }, (_, si) => {
                      const pal = STEP_PALETTE[si % STEP_PALETTE.length];
                      return stepSubFields.map((f, fi) => (
                        <th key={`${si}-${fi}`} style={{
                          padding: '7px 10px', textAlign: 'left', fontWeight: 700, fontSize: 10,
                          background: pal.fieldBg, color: '#374151',
                          borderBottom: '2px solid #e5e7eb', whiteSpace: 'pre-line', lineHeight: 1.35,
                          borderLeft: fi === 0 ? `3px solid ${pal.grpBorder}` : undefined,
                          borderRight: f.isLast ? `3px solid ${pal.grpBorder}88` : undefined,
                        }}>{f.label}</th>
                      ));
                    })}
                  </tr>
                </thead>
                <tbody>
                  {filteredJournals.slice((excelModalPage - 1) * MODAL_PAGE_SIZE, excelModalPage * MODAL_PAGE_SIZE).map((j, jOffset) => {
                    const ji = (excelModalPage - 1) * MODAL_PAGE_SIZE + jOffset;
                    const statusInfo = STATUS_MAP[j.statusflow] || { label: j.statusflow, color: '#6c757d', bg: '#f8f9fa' };
                    const allDone = j.steps.length > 0 && j.steps.every(s => s.approvejour);
                    const completedSteps = j.steps.filter(s => s.approvejour).length;
                    const progressPct = j.steps.length > 0 ? Math.round((completedSteps / j.steps.length) * 100) : 0;
                    const displayStatus = allDone ? { label: 'เสร็จเรียบร้อย', color: '#059669', bg: '#d1fae5' } : statusInfo;
                    const firstSent = j.steps.find(s => s.waitjour)?.waitjour;
                    const lastApproved = [...j.steps].reverse().find(s => s.approvejour)?.approvejour;
                    let totalMinutes = null;
                    if (firstSent && lastApproved) {
                      const diff = Math.round((new Date(lastApproved) - new Date(firstSent)) / 60000);
                      if (diff > 0) totalMinutes = diff;
                    }
                    const rowBg = ji % 2 === 0 ? '#fff' : '#f9fafb';
                    const td = (extra = {}) => ({ padding: '7px 10px', borderBottom: '1px solid #f3f4f6', background: rowBg, verticalAlign: 'middle', fontSize: 11, ...extra });

                    return (
                      <tr key={j.journalId}>
                        {/* Doc info */}
                        <td style={td({ color: '#9ca3af' })}>{ji + 1}</td>
                        <td style={td({ fontWeight: 700, color: '#1f2937', whiteSpace: 'nowrap' })}>{j.tdscode}</td>
                        <td style={td({ color: '#6b7280' })}>{j.revision}</td>
                        <td style={td()}>
                          <span style={{ fontSize: 10, fontWeight: 700, color: displayStatus.color, background: displayStatus.bg, padding: '2px 8px', borderRadius: 8, border: `1px solid ${displayStatus.color}44`, whiteSpace: 'nowrap' }}>
                            {displayStatus.label}
                          </span>
                        </td>
                        <td style={td({ color: '#6b7280', textAlign: 'center' })}>{completedSteps}/{j.steps.length}</td>
                        <td style={td({ minWidth: 80 })}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <div style={{ flex: 1, height: 5, background: '#e5e7eb', borderRadius: 3, overflow: 'hidden' }}>
                              <div style={{ height: '100%', width: `${progressPct}%`, background: displayStatus.color, borderRadius: 3 }} />
                            </div>
                            <span style={{ fontSize: 10, fontWeight: 700, color: displayStatus.color, flexShrink: 0 }}>{progressPct}%</span>
                          </div>
                        </td>
                        <td style={td()}>
                          {totalMinutes != null
                            ? <span style={{ fontSize: 10, fontWeight: 700, color: '#6d28d9', background: '#ede9fe', padding: '2px 7px', borderRadius: 7, whiteSpace: 'nowrap' }}>{formatDuration(totalMinutes)}</span>
                            : <span style={{ color: '#d1d5db' }}>-</span>}
                        </td>
                        <td style={td({ borderRight: '3px solid #94a3b8' })}>
                          {totalMinutes != null
                            ? <span style={{ fontSize: 10, fontWeight: 700, color: '#6d28d9', background: '#ede9fe', padding: '2px 7px', borderRadius: 7, whiteSpace: 'nowrap' }}>{formatDurationDays(totalMinutes)}</span>
                            : <span style={{ color: '#d1d5db' }}>-</span>}
                        </td>

                        {/* Step cells — each step = S columns */}
                        {Array.from({ length: maxSteps }).flatMap((_, si) => {
                          const pal = STEP_PALETTE[si % STEP_PALETTE.length];
                          const step = j.steps[si];
                          const borderL = { borderLeft: `3px solid ${pal.grpBorder}` };
                          const borderR = { borderRight: `3px solid ${pal.grpBorder}88` };
                          const emptyStyle = { ...td({ background: `${pal.grpBg}55` }), color: '#d1d5db', textAlign: 'center' };

                          if (!step) {
                            return Array.from({ length: S }, (_, fi) => (
                              <td key={`${si}-${fi}`} style={{ ...emptyStyle, ...(fi === 0 ? borderL : {}), ...(fi === S - 1 ? borderR : {}) }}>—</td>
                            ));
                          }

                          const stepStatus = getStepStatus(step, j.current_stateflow);
                          const sc = STEP_COLORS[stepStatus] || STEP_COLORS.pending;
                          const nextStep = si < j.steps.length - 1 ? j.steps[si + 1] : null;
                          const waitToReceive = step.duration_1003_to_1004 != null ? Number(step.duration_1003_to_1004) : null;
                          let receiveToApprove = null;
                          if (step.recievjour && step.approvejour) {
                            const diff = Math.round((new Date(step.approvejour) - new Date(step.recievjour)) / 60000);
                            if (diff > 0) receiveToApprove = diff;
                          }
                          let betweenSteps = null;
                          if (step.approvejour && nextStep?.recievjour) {
                            const diff = Math.round((new Date(nextStep.recievjour) - new Date(step.approvejour)) / 60000);
                            if (diff > 0) betweenSteps = diff;
                          }

                          return [
                            <td key={`${si}-0`} style={{ ...td({ maxWidth: 130, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }), ...borderL }}>
                              {step.approvedepartment || '-'}
                            </td>,
                            <td key={`${si}-1`} style={td()}>
                              <span style={{ fontSize: 10, fontWeight: 700, color: sc.badgeText, background: sc.badgeBg, padding: '2px 7px', borderRadius: 7, whiteSpace: 'nowrap' }}>{sc.label}</span>
                            </td>,
                            <td key={`${si}-2`} style={td({ color: '#92400e', whiteSpace: 'nowrap' })}>{step.waitjour ? formatDate(step.waitjour) : <span style={{ color: '#d1d5db' }}>-</span>}</td>,
                            <td key={`${si}-3`} style={td()}>{durBadge(waitToReceive != null && waitToReceive > 0 ? waitToReceive : null, '#92400e', '#fef3c7')}</td>,
                            <td key={`${si}-4`} style={td({ color: '#92400e', whiteSpace: 'nowrap', fontSize: 10 })}>{formatDurationDHM(waitToReceive != null && waitToReceive > 0 ? waitToReceive : null)}</td>,
                            <td key={`${si}-5`} style={td({ color: '#1d4ed8', whiteSpace: 'nowrap' })}>{step.recievjour ? formatDate(step.recievjour) : <span style={{ color: '#d1d5db' }}>-</span>}</td>,
                            <td key={`${si}-6`} style={td()}>{durBadge(receiveToApprove, '#1e40af', '#dbeafe')}</td>,
                            <td key={`${si}-7`} style={td({ color: '#1e40af', whiteSpace: 'nowrap', fontSize: 10 })}>{formatDurationDHM(receiveToApprove)}</td>,
                            <td key={`${si}-8`} style={td({ color: '#065f46', whiteSpace: 'nowrap' })}>{step.approvejour ? formatDate(step.approvejour) : <span style={{ color: '#d1d5db' }}>-</span>}</td>,
                            <td key={`${si}-9`} style={td()}>{durBadge(betweenSteps, '#9d174d', '#fce7f3')}</td>,
                            <td key={`${si}-10`} style={{ ...td({ color: '#9d174d', whiteSpace: 'nowrap', fontSize: 10 }), ...borderR }}>{formatDurationDHM(betweenSteps)}</td>,
                          ];
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            );
          })()}
        </Modal.Body>
        <Modal.Footer style={{ background: '#f9fafb', borderTop: '1px solid #e5e7eb', flexDirection: 'column', gap: 10, alignItems: 'stretch' }}>
          {renderPagination(excelModalPage, Math.ceil(filteredJournals.length / MODAL_PAGE_SIZE), setExcelModalPage, filteredJournals.length, MODAL_PAGE_SIZE)}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 12, color: '#6b7280' }}>
            จะ Export ข้อมูลทั้งหมด <strong>{filteredJournals.length}</strong> รายการ เป็น 2 sheet (สรุปเอกสาร + รายละเอียดขั้นตอน)
          </span>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={() => setExcelModal({ show: false })}
              style={{
                padding: '8px 18px', borderRadius: 8, border: '1px solid #e5e7eb',
                background: '#fff', color: '#374151', fontSize: 13, fontWeight: 600, cursor: 'pointer',
              }}
            >ยกเลิก</button>
            <button
              onClick={() => { exportToExcel(); setExcelModal({ show: false }); }}
              style={{
                display: 'flex', alignItems: 'center', gap: 7,
                padding: '8px 20px', borderRadius: 8, border: 'none',
                background: 'linear-gradient(135deg, #1a7f5a, #28B463)',
                color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(40,180,99,0.35)',
              }}
            >
              <FaFileExcel size={14} />
              Load Excel
            </button>
          </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Modal แสดงรายละเอียดผู้รออนุมัติ */}
      <Modal
        show={approveModal.show}
        onHide={() => setApproveModal(prev => ({ ...prev, show: false }))}
        centered
        size="md"
      >
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #1a7f5a 0%, #28B463 100%)', borderBottom: 'none' }}>
          <Modal.Title style={{ color: '#fff', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
            <FaUserCheck size={16} />
            รอดำเนินการ — ขั้นตอนที่ {approveModal.stateflow}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '20px 24px' }}>
          {approveModal.journalInfo && (
            <div style={{
              background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 10,
              padding: '10px 14px', marginBottom: 16,
              display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center',
            }}>
              <span style={{ fontWeight: 700, fontSize: 14, color: '#065f46' }}>{approveModal.journalInfo.tdscode}</span>
              <span style={{ fontSize: 12, color: '#6b7280', background: '#e5e7eb', borderRadius: 6, padding: '2px 8px' }}>
                Rev.{approveModal.journalInfo.revision}
              </span>
              <span style={{ fontSize: 12, color: '#374151' }}>
                <FaUser size={10} style={{ marginRight: 4, color: '#6b7280' }} />
                {approveModal.journalInfo.creatorname || approveModal.journalInfo.createby}
              </span>
            </div>
          )}

          {approveModal.loading ? (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '32px 0', gap: 12 }}>
              <Spinner animation="grow" variant="success" style={{ width: 36, height: 36 }} />
              <div style={{ color: '#6b7280', fontSize: 13 }}>กำลังโหลดข้อมูล...</div>
            </div>
          ) : approveModal.data.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '32px 0', color: '#9ca3af', fontSize: 14 }}>
              ไม่พบข้อมูลผู้อนุมัติในขั้นตอนนี้
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>
                ผู้มีสิทธิ์อนุมัติในขั้นตอนนี้ ({approveModal.data.length} คน)
              </div>
              {approveModal.data.slice((approveModalPage - 1) * APPROVE_PAGE_SIZE, approveModalPage * APPROVE_PAGE_SIZE).map((person, idx) => (
                <div key={idx} style={{
                  display: 'flex', alignItems: 'center', gap: 12,
                  background: '#f9fafb', border: '1px solid #e5e7eb',
                  borderRadius: 10, padding: '12px 14px',
                }}>
                  <div style={{
                    width: 40, height: 40, borderRadius: '50%',
                    background: 'linear-gradient(135deg, #1a7f5a, #28B463)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    flexShrink: 0,
                  }}>
                    <FaUser size={16} color="#fff" />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 700, fontSize: 14, color: '#1f2937', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {person.approveby || '-'}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginTop: 3 }}>
                      <FaBuilding size={10} color="#6b7280" />
                      <span style={{ fontSize: 12, color: '#6b7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {person.department || '-'}
                      </span>
                    </div>
                    <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>
                      รหัส: {person.emcode || '-'}
                    </div>
                  </div>
                  <div style={{
                    background: '#fef3c7', border: '1px solid #f59e0b44',
                    borderRadius: 8, padding: '4px 10px',
                    fontSize: 11, fontWeight: 700, color: '#92400e', flexShrink: 0,
                  }}>
                    รอดำเนินการ
                  </div>
                </div>
              ))}
              {approveModal.data.length > APPROVE_PAGE_SIZE && (
                <div style={{ marginTop: 4, padding: '10px 0 2px', borderTop: '1px solid #e5e7eb' }}>
                  {renderPagination(approveModalPage, Math.ceil(approveModal.data.length / APPROVE_PAGE_SIZE), setApproveModalPage, approveModal.data.length, APPROVE_PAGE_SIZE)}
                </div>
              )}
            </div>
          )}
        </Modal.Body>
      </Modal>
  </div>
  );
};

export default Journalstepflow;
